import SWSLogoBlack from '@assets/images/logo/sws-logo-black.svg';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { RouterLink } from '@redux-first-router-link';
import {
  BrandingWrapper,
  BrandingContent,
  ImageLogo,
  SWSLogoBlackWrapper,
  PoweredByWrapper,
} from './styled';
import { Grid, Text } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';
import { getLocation } from '@/redux/location/selectors';
import { useSelector } from 'react-redux';
import { useHomeRoute } from '@/hooks/useHomeRoute';
import { useTranslation } from '@/hooks/useTranslation';
type BrandingBarProps = {
  logo?: string;
};
export const BrandingBar = ({ logo }: BrandingBarProps) => {
  const { trackEvent } = useTracking();
  const locationState = useSelector(getLocation);
  const location = locationState?.type ?? '';
  const homeRoute = useHomeRoute();
  const t = useTranslation();

  return (
    <BrandingWrapper
      as="header"
      displayFlex
      justifyContent="center"
      data-cy-id="branding-wrapper"
    >
      <BrandingContent>
        <Grid templateColumns="50% 50%">
          <Grid>
            {typeof logo === 'string' && logo !== '' && (
              <ImageLogo src={logo} alt="company logo" />
            )}
          </Grid>
          <Grid alignContent="center" justifyContent="end">
            <PoweredByWrapper alignItem="center">
              <Text typography="tiny" opacity={0.5} color="noirRGBA">
                {t('app.topbar.nav.poweredBy')}
              </Text>
              <SWSLogoBlackWrapper>
                <RouterLink
                  to={{ type: homeRoute }}
                  onClick={() =>
                    location !== ROUTE_DASHBOARD &&
                    trackEvent({
                      action: 'click',
                      modifier: 'logo',
                    })
                  }
                >
                  <SWSLogoBlack />
                </RouterLink>
              </SWSLogoBlackWrapper>
            </PoweredByWrapper>
          </Grid>
        </Grid>
      </BrandingContent>
    </BrandingWrapper>
  );
};
